import React, { useState } from "react";
import { FaSearchPlus } from "react-icons/fa";
import Modal from "../../components/modal/modal";
import {
  MAX_CONTEUDOS_REGULARES,
  MAX_VAGAS_POR_CONTEUDO,
  idsConteudosRegulares,
} from "./conteudosAgendaUtils";

function CardConteudo({ evento, ativo, disponivel, onToggle }) {
  const cheio = (evento?.count_participantes || 0) >= MAX_VAGAS_POR_CONTEUDO;

  return (
    <button
      type="button"
      className={`cc-conteudo ${ativo ? "cc-conteudo--ativo" : ""} ${
        !disponivel || cheio ? "cc-conteudo--bloqueado" : ""
      } ${cheio ? "cc-conteudo--cheio" : ""}`}
      disabled={!disponivel || cheio}
      title={cheio ? "Vagas esgotadas" : undefined}
      onClick={() => {
        if (!cheio && disponivel) onToggle();
      }}
    >
      <span className="cc-conteudo-nome">{evento?.nome}</span>
      {cheio ? <span className="cc-conteudo-badge">Esgotado</span> : null}
    </button>
  );
}

/**
 * Bloco de horário com escolha mutuamente exclusiva entre as opções do slot.
 * Conteúdos: máx. 2 no total.
 */
export default function BlocoConteudoEscolha({
  horario,
  eventos = [],
  selectedIds = [],
  onChangeSelected,
  disponivel = true,
  catalogo = [],
}) {
  const [showModal, setShowModal] = useState(false);
  const [detalheModal, setDetalheModal] = useState(null);

  const idsDoBloco = eventos.map((e) => e.id).filter(Boolean);
  const selecionadoNoBloco = selectedIds.find((id) => idsDoBloco.includes(id));

  const toggleEvento = (eventoId) => {
    const unicos = [...new Set(selectedIds)];
    const jaSelecionado = unicos.includes(eventoId);

    if (jaSelecionado) {
      onChangeSelected(unicos.filter((id) => id !== eventoId));
      return;
    }

    // Remove qualquer outra opção já escolhida neste horário
    let next = unicos.filter((id) => !idsDoBloco.includes(id));

    const regulares = idsConteudosRegulares(next, catalogo);
    if (
      regulares.length >= MAX_CONTEUDOS_REGULARES &&
      !regulares.includes(eventoId)
    ) {
      return;
    }

    next = [...next, eventoId];
    onChangeSelected(next);
  };

  const abrirDetalhe = (item) => {
    const linhas = item.detalhe ? String(item.detalhe).split("<br/>") : [];
    setDetalheModal({ nome: item.nome, linhas });
    setShowModal(true);
  };

  return (
    <div className="cc-bloco">
      <Modal
        titulo="Detalhes do conteúdo"
        labelTo=""
        show={showModal}
        toggleModal={() => setShowModal(!showModal)}
      >
        {detalheModal ? (
          <div>
            <b>{detalheModal.nome}</b>
            <br />
            <br />
            {detalheModal.linhas.map((linha, i) => (
              <p key={i}>{linha}</p>
            ))}
          </div>
        ) : null}
      </Modal>

      <div className="cc-bloco-header">
        <span>{horario}</span>
        {!disponivel ? (
          <span className="cc-bloco-indisponivel">Horário indisponível</span>
        ) : null}
      </div>

      <div
        className={`cc-bloco-opcoes ${
          disponivel ? "" : "cc-bloco-opcoes--bloqueado"
        }`}
      >
        {eventos.map((evento) =>
          evento ? (
            <div key={evento.id} className="cc-bloco-opcao">
              <CardConteudo
                evento={evento}
                ativo={selecionadoNoBloco === evento.id}
                disponivel={disponivel}
                onToggle={() => toggleEvento(evento.id)}
              />
              <button
                type="button"
                className="cc-bloco-detalhe"
                aria-label={`Detalhes de ${evento.nome}`}
                onClick={() => abrirDetalhe(evento)}
              >
                <FaSearchPlus />
              </button>
            </div>
          ) : null,
        )}
      </div>
    </div>
  );
}
